import { MarketplaceIntelligenceBaseApiClient } from '../marketplace-intelligence/client';
import type {
  CrawlHealth,
  CrawlSpend,
  CrawlVisit,
  CrawlVisitsPage,
  CrawlVisitsQuery
} from '@interfaces/Crawl.interface';

function headerNumber(value: unknown, fallback: number): number {
  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export class ApiCrawl extends MarketplaceIntelligenceBaseApiClient {
  getHealth(): Promise<CrawlHealth> {
    return this.get<CrawlHealth>('/api/v1/crawl/health');
  }

  getSpend(months = 1): Promise<CrawlSpend> {
    return this.get<CrawlSpend>('/api/v1/crawl/spend', {
      params: { months }
    });
  }

  /** The visit count comes back in the X-Total-Count header, not the body. */
  async getVisits(query: CrawlVisitsQuery = {}): Promise<CrawlVisitsPage> {
    const params = Object.fromEntries(
      Object.entries(query).filter(
        ([, value]) => value !== undefined && value !== ''
      )
    );
    const response = await this.client.get<CrawlVisit[]>(
      '/api/v1/crawl/visits',
      { params }
    );
    const items = response.data ?? [];
    return {
      items,
      total: headerNumber(response.headers['x-total-count'], items.length),
      offset: headerNumber(response.headers['x-offset'], query.offset ?? 0),
      limit: headerNumber(response.headers['x-limit'], query.limit ?? 50)
    };
  }
}

export { crawlQueryKeys } from './query-keys';
export * from './use-crawl-queries';
